import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useSuggestedAnswers } from "./ExpertSuggestedAnswersHook";
// Set the default state values for each context
export const ExpertSuggestedAnswersContext = /*#__PURE__*/createContext({});
export const ExpertSuggestedAnswersContextProvider = ({
  children
}) => {
  const suggestedAnswersState = useSuggestedAnswers();
  return /*#__PURE__*/React.createElement(ExpertSuggestedAnswersContext.Provider, {
    value: suggestedAnswersState
  }, children);
};
export const useExpertSuggestedAnswersContext = () => {
  return useContext(ExpertSuggestedAnswersContext);
};
ExpertSuggestedAnswersContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};